import React from "react";
import supportservice from "../../Assets/support/supportservice.png";
import supportmessenger from "../../Assets/support/supportmessenger.png";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Navbar";

export default function Support() {
  return (
    <div>
      <Navbar />
      <div className="font-[Roboto]">
        <div className="text-white text-2xl py-8 sm:px-12 px-4 flex items center bg-[#2EBAA3]">
          <span>Contact us</span>
        </div>
        <div className="sm:px-12 px-4 font-light my-4 flex lg:flex-row flex-col-reverse items-center text-justify">
          <div className="md:mr-4">
            <p className="leading-relaxed">
              ProLegion was founded by a group of Information Technology
              industry Consultants with over 50 years of combined experience,
              and a thorough understanding of different information technology
              solutions available in the marketplace. ProLegion is a platform
              dedicated to directly connecting IT Consultants, Clients and
              Vendors. Whether you're in need of the right specialist to help
              your company with various software solutions or are an experienced
              IT consultant looking.
            </p>

            <p className="mt-8 leading-relaxed">
              ProLegion was founded by a group of Information Technology
              industry Consultants with over 50 years of combined experience,
              and a thorough understanding of different information technology
              solutions available in the marketplace.
            </p>
          </div>
          <div className="flex justify-center">
            <img className="md:h-[350px] lg:w-[1250px]" src={supportservice} />
          </div>
        </div>
      </div>

      {/* Contact Us */}
      <div
        className="my-8 sm:mx-12 mx-4"
        style={{
          boxSizing: "border-box",
          border: " 1px solid #787878",
          borderRadius: "9px",
        }}
      >
        <div
          style={{
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "24px",
            lineHeight: " 36px",
            paddingTop: "32px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          Contact Us
        </div>
        <div
          style={{ display: "flex", alignItems: "center" }}
          className="flex lg:flex-row flex-col lg:mt-0 mt-8 justify-evenly"
        >
          <div>
            <div className="flex flex-row space-x-4 justify-center items-center">
              <img className="md:h-[350px] md:w-[450px]" src={supportmessenger} />
              {/* <span
                style={{ color: "#139588" }}
                className="text-5xl font-semibold"
              >
                @
              </span>
              <span
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "24px",
                  lineHeight: "36px",
                }}
              >
                Email :
              </span> */}
            </div>
            {/* contactus@ProLegion.com */}
          </div>
          <div>
            <div className="flex md:flex-row flex-col my-12 md:space-x-20">
              <input
                style={{ border: "1px solid #787878", borderRadius: "4px" }}
                className="homeInputClass p-4 md:mb-0 mb-12 md:w-full w-72"
                placeholder="Your Name"
              />
              <input
                style={{ border: "1px solid #787878", borderRadius: "4px" }}
                className="homeInputClass p-4 md:w-full w-72"
                placeholder="Your Email ID"
              />
            </div>
            <div className="my-12">
              <input
                style={{ border: "1px solid #787878", borderRadius: "4px" }}
                className="homeInputClass p-4 md:w-full w-72"
                placeholder="Subject"
              />
            </div>
            <div className="mt-12 mb-28">
              <input
                style={{ border: "1px solid #787878", borderRadius: "4px" }}
                className="homeInputClass p-4 md:w-full h-36 w-72"
                placeholder="Your Message"
              />

              <div className="">
                <button
                  style={{
                    position: "absolute",
                    width: "191px",
                    height: "50px",
                    background: "#139588",
                    borderRadius: "25px",
                    marginTop: "30px",
                    color: "white",
                  }}
                >
                  Send Message
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
